import React, { Component } from "react";
import classnames from "classnames";

import SlidesComments from "./SlidesComments";
import styles from "./PreparePresentation.local.scss";

class SlideCommentsFrame extends Component {
  render() {
    const { data, slideIndex } = this.props;
    return (
      <div
        className={classnames(
          "columns medium-12 small-12",
          styles.comments_slide_container
        )}
      >
        {//eslint-disable-next-line array-callback-return
        Object.values(data.slides).map((slide, i) => {
          if (i === slideIndex && i < Object.values(data.slides).length - 1) {
            return (
              !["EXTRA_SLIDE", "QUESTIONS_SLIDE", "THANKING_SLIDE"].includes(
                slide.layout.type
              ) && (
                <SlidesComments
                  slideId={data.slides[slideIndex].code}
                  handleInputChange={this.props.handleInputChange}
                  keyPressed={this.props.keyPressed}
                  saveComment={this.props.saveComment}
                  clearComment={this.props.clearComment}
                  deleteComment={this.props.deleteComment}
                  updateComment={this.props.updateComment}
                  saveVoiceComment={this.props.saveVoiceComment}
                />
              )
            );
          }
        })}
      </div>
    );
  }
}

export default SlideCommentsFrame;



// WEBPACK FOOTER //
// ./src/components/PreparePresentation/SlideCommentsFrame.js